import BaseComponent from "../../../baseComponent.js";
import Expression from "./expression.jsx";
import Label  from "./label.jsx";
import Color  from "./color.jsx";
import Actions  from "./actions.jsx";
import styles from "./styles.scss";

export default class TechnicalAnalysisConfig extends BaseComponent {
  constructor(props) {
    super(props);
  }

  render() {
    let expression, label;
    if (this.props.legend.expressions.hasOwnProperty("y")) {
      expression = <Expression label="Data"
                               expressionKey="y"
                               widgetId={this.props.widgetId}
                               legendId={this.props.legend.id}
                               onLegendChange={this.props.onLegendChange}
                               expression={this.props.legend.expressions.y}
                               mappings={this.props.legend.mappings}/>;
      label = <Label label={this.props.legend.parameters.legendLabel}
                     onLegendChange={this.props.onLegendChange}/>;
    }
    return (
      <div className={styles.legendConfig} name="legendConfig">
        <div className={styles.legendConfigContent}>
          <Actions closeLegendConfig={this.props.closeLegendConfig} allowCopy={false}/>
          {label}
          {expression}
          <Color color={this.props.legend.parameters.legendColor}
                 onLegendChange={this.props.onLegendChange}/>
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/dashboard/add-widget/legend-config/technicalAnalysisConfig.jsx